import { useQuery } from '@tanstack/react-query'

import { getUserCardsLightForRoleResources } from '@src/api'
import { DefaultApiGetUserCardsLightForRoleResourcesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchUserCardsLightForRoleResources = (
  params: DefaultApiGetUserCardsLightForRoleResourcesRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.userId,
    queryFn: () => getUserCardsLightForRoleResources(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_USER_CARDS_LIGHT_FOR_ROLE_RESOURCES,
      params.userId,
    ],
  })
}
